import { Checkbox, CheckboxProps } from '@hub/checkbox'
import { Link } from '@hub/link'
import React from 'react'
import { useLocation } from '@scentregroup/shared/next/compat/location'
import { useRouter } from '@scentregroup/shared/next/router'

interface ICheckboxWithLinkProps extends CheckboxProps {
  onLinkClick: (event: React.MouseEvent) => void
  name: string
  value: string
}

const createLinkFromCheckboxValue = (
  pathname: string,
  search: string,
  name: string,
  value: string
): string => {
  const usp = new URLSearchParams(search)
  let values = usp.getAll(name)
  if (values.includes(value)) {
    values = values.filter(x => x !== value)
  } else {
    values.push(value)
  }
  usp.delete(name)
  values.sort().forEach(val => usp.append(name, val))
  return `${pathname}?${usp.toString()}`
}

export const CheckboxWithLink: React.FC<
  React.PropsWithChildren<ICheckboxWithLinkProps>
> = ({ onLinkClick, name, value, children, ...props }) => {
  const { basePath } = useRouter()
  const { pathname, search } = useLocation()
  const href = React.useMemo(
    () =>
      createLinkFromCheckboxValue(
        `${basePath}${pathname}`,
        search,
        name,
        value
      ),
    [basePath, pathname, search, name, value]
  )
  return (
    <Checkbox value={value} {...props}>
      <Link href={href} hasUnderline={false} onClick={onLinkClick}>
        {children}
      </Link>
    </Checkbox>
  )
}
